const money = (v) => Number(v || 0).toLocaleString('es-PE', { style: 'currency', currency: 'PEN' });
const getAbonadoPorStyles = (abonadoPor) => {
  const value = String(abonadoPor || '').toUpperCase();
  if (value === 'CUENTA CORRIENTE') return 'bg-red-100 text-red-800 border border-red-200';
  if (value === 'CAJA CHICA') return 'bg-yellow-100 text-yellow-800 border border-yellow-200';
  return 'bg-gray-100 text-gray-800';
};

export default function PrestamosActivosTable({ 
  rows = [], 
  loading = false, 
  error = '',
  pagination = null,
  onPageChange = null 
}) {
  return (
    <>
      {error && (
        <div className="mt-3 bg-red-50 text-red-700 p-4 rounded-lg border border-red-200">
          {error}
        </div>
      )}

      <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead>
              <tr className="text-[11px] font-semibold uppercase tracking-[0.2em] text-gray-500 bg-gray-50 border-b border-gray-200">
                <th className="py-3 px-3 text-center">PRÉSTAMO</th>
                <th className="py-3 px-3 text-center">CLIENTE</th>
                <th className="py-3 px-3 text-center">MONTO</th>
                <th className="py-3 px-3 text-center">TASA %</th>
                <th className="py-3 px-3 text-center">CUOTAS PAGADAS</th>
                <th className="py-3 px-3 text-center">CUOTAS PENDIENTES</th>
                <th className="py-3 px-3 text-center">SALDO PENDIENTE</th>
                <th className="py-3 px-3 text-center">FECHA VENC.</th>
                <th className="py-3 px-3 text-center">ABONADO POR</th>
                <th className="py-3 px-3 text-center">TELÉFONO</th>
                <th className="py-3 px-3 text-center">DIRECCIÓN</th>
              </tr>
            </thead>

            <tbody>
              {rows.length === 0 && (
                <tr>
                  <td className="py-8 px-4 text-center text-gray-500" colSpan={11}>
                    {loading ? 'Cargando…' : 'Sin resultados'}
                  </td>
                </tr>
              )}

              {rows.map((r) => {
                const abonadoPor = r.abonado_por || r.prestamo?.abonado_por;
                return (
                  <tr
                    key={`${r.idPrestamo}`}
                    className="border-b border-gray-200 last:border-b-0 transition hover:bg-rose-50/40 odd:bg-white even:bg-gray-50/40"
                  >

                    <td className="py-3 px-3 text-center">
                      <span className="font-medium text-gray-900">
                        #{r.idPrestamo}
                      </span>
                    </td>

                    <td className="py-3 px-3">
                      <div className="flex flex-col">
                        <span className="font-medium text-gray-900 text-sm">
                          {r.cliente}
                        </span>
                      </div>
                    </td>

                    <td className="py-3 px-3 text-right font-semibold text-gray-900">
                      {money(r.monto_prestamo)}
                    </td>

                    <td className="py-3 px-3 text-center">
                      <span className="inline-flex items-center justify-center px-2.5 py-1 rounded-full text-xs font-semibold bg-red-100 text-red-800">
                        {Number(r.tasa_interes).toFixed(2)}%
                      </span>
                    </td>

                    <td className="py-3 px-3 text-center">
                      <span className="inline-flex items-center justify-center px-3 py-1 rounded-full text-sm font-semibold bg-green-100 text-green-800">
                        {r.cuotas_pagadas}
                      </span>
                    </td>

                    <td className="py-3 px-3 text-center">
                      <span className={`inline-flex items-center justify-center px-3 py-1 rounded-full text-sm font-semibold ${r.cuotas_pendientes <= 2
                          ? 'bg-orange-100 text-orange-800'
                          : 'bg-gray-100 text-gray-800'
                        }`}>
                        {r.cuotas_pendientes}
                      </span>
                    </td>

                    <td className="py-3 px-3 text-center font-semibold">
                      <span className={`${r.saldo_pendiente > 0 ? 'text-gray-900' : 'text-green-600'}`}>
                        {money(r.saldo_pendiente)}
                      </span>
                    </td>

                    <td className="py-3 px-3 text-center">
                      <span className="text-sm text-gray-700">
                        {r.fecha_ultima_cuota}
                      </span>
                    </td>

                    <td className="py-3 px-3 text-center">
                      <span className={`text-xs px-2.5 py-1 rounded-full font-medium whitespace-nowrap ${getAbonadoPorStyles(abonadoPor)}`}>
                        {abonadoPor || 'N/A'}
                      </span>
                    </td>

                    <td className="py-3 px-3 text-gray-700 text-sm">
                      {r.telefono}
                    </td>

                    <td className="py-3 px-3 text-gray-600 text-xs max-w-xs truncate" title={r.direccion}>
                      {r.direccion}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        {loading && rows.length > 0 && (
          <div className="p-4">
            <div className="mx-auto h-1 w-32 bg-gray-100 rounded overflow-hidden">
              <div className="h-full w-1/2 animate-pulse bg-red-600"></div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}